import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { TokenService } from '@app/auth/services/token.service';
import { LocalStorageItem } from '@app/auth/auth.constants';
import { ErrorStatus } from '@app/constants/error-handling.constants';
import { TokenRefreshResponse } from '@app/auth/services/token-refresh-response.model';
import { AuthDOS } from '@app/auth/services/auth-dos.service';
import { ssoAuthRedirectUrl } from '@app/constants/auth-constants';
import { AppConfigService } from '@app/services/app-config.service';

@Injectable()
export class TokenExpireInterceptor implements HttpInterceptor {
  constructor(
    private _tokenService: TokenService,
    private _authDOS: AuthDOS,
    private _appConfigService: AppConfigService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (request.url.includes(this._appConfigService.config.authUrl) || err.status === ErrorStatus.NotFoundUser) {
            this.signOut();
            return throwError(err);
          }

          if (err.status !== ErrorStatus.Unauthorized) {
            return throwError(err);
          }
        }

        if (!this._tokenService.isRefreshTokenPresent()) {
          this.signOut();
        }

        return this._tokenService.refreshTokens().pipe(
          switchMap((tokens: TokenRefreshResponse) => {
            return next.handle(this.addAuthToken(request));
          })
        );
      })
    );
  }

  addAuthToken(request: HttpRequest<unknown>): HttpRequest<unknown> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this._tokenService.getAccessToken()}`
      }
    });
  }

  signOut(): void {
    localStorage.removeItem(LocalStorageItem.IsLogged);
    this._tokenService.deleteTokens();
    this._authDOS.updateUser(null);
    this._authDOS.setAuthTokenFalse();
    window.location.replace(this._appConfigService.config.authUrl.concat(ssoAuthRedirectUrl));
  }
}
